export const BIRTH_DATE_MAXIMUM = 110;
export const TITLES = ['-', 'Dr.', 'Ifj.', 'Id.', 'Prof.'];
export const CAPTCHA_ERROR = 'captchaText';
